import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';

@Component({
  selector: 'app-all-sponsers',
  templateUrl: './all-sponsers.component.html',
  styleUrls: ['./all-sponsers.component.css']
})
export class AllSponsersComponent implements OnInit {

  banners: Array<any> = [];

  constructor() { }

  ngOnInit() {
    this.getBanners();
  }

  getBanners() {
    firebase.database().ref('banners')
    .once("value")
    .then(snapshot => {
      var data = snapshot.val();

      for(var key in data) {
        var banner = data[key];

        banner.key = key;

        this.banners.push(banner);
      }
    })
  }

}
